module.exports = __webpack_public_path__ + "static/media/menu.60c35e33.svg";